<template>
  <div class="product-upload" :class="addClass">
    <div class="container container_sm">
      <div class="row row-dop">
        <div class="col-lg-12 d-flex justify-content-center">
          <div class="poz_rel product-upload-wrapper">
            <div class="wrapper_file_upload"
                 :class="{ highlight: highlight }"
                 @dragover.prevent
                 @drop.stop.prevent="handleDrop"
                 @dragenter.stop.prevent="onDragEnter"
                 @dragleave.stop.prevent="onDragLeave"
            >
              <label v-show="!selectedFile" class="file_upload">
                <input
                  @change="onFilePicked"
                  accept="image/*"
                  class="inputfile"
                  type="file"
                  name="file"
                  ref="file"
                />


              <!-- <img class="upload_img" src="../../assets/images/svg/upload.svg" alt="upload" /> -->
              <div class="text1 color-black" v-html="$t(this.texts.receiptUpload1)"></div>
              <div class="text2 color-black" v-html="$t(this.texts.receiptUpload2)"></div>
              </label>
              <div v-show="selectedFile" class="row row-dop justify-content-center mt-4">
                <label class="wrapper_square_img">
                  <img
                    class="square-img img-fluid"
                    ref="preview"
                    src="../../assets/icons/placeholder.svg"
                    alt
                  />
                  <div @click="removeImage" class="delete_block">
                    <img class="delete_img" src="../../assets/icons/delete.svg" alt="delete" />
                  </div>
                </label>
              </div>
              <button href="#" @click.prevent="$refs.file.click()" @keypress.enter="$refs.file.click()" tabindex="0" class="btn btn_abs btn-light">{{ $t(this.texts.choose) }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-upload",
  props: {
    fieldId: String,
    apiUrl: String,
    successAction: {
      type: Object,
      required: true
    },
    value: {
      required: false
    },
    title: {
      type: String,
      default: "Laden Sie Ihr Foto hoch"
    },
    uploadText: {
      type: String,
      default: "Datei auswählen"
    },
    colorSchema: {
      required: false,
      type: String,
      default: "#8B8B8B"
    },
    tokenName: {
      required: false,
      type: String,
      default: "token"
    },
    reUpload: {
      required: false,
      type: Boolean
    },
    texts: {
      required: false,
      type: Object,
      default: () => {}
    },
    "addClass": String
  },
  data () {
    return {
      selectedFile: null,
      uploadSectionHover: false,
      highlight: false
    };
  },
  components: {},
  methods: {
    clear () {
      this.selectedFile = null;
      this.setValue(null);
    },
    removeImage () {
      this.selectedFile = null;
      this.setValue(null);
      this.$refs.file.value = null;
    },
    onFilePicked (event) {
      const files = event.target.files || event.dataTransfer.files;
      this.handleFiles(files)
    },
    onDragEnter () {
      this.highlight = true
    },
    onDragLeave () {
      this.highlight = false
    },
    handleDrop (e) {
      let dt = e.dataTransfer
      let files = dt.files
      this.handleFiles(files)
    },
    handleFiles (files) {
      const maxfilesize = 1024 * 1024 * 16; // 1 Mb

      if (files && files[0]) {
        let filename = files[0].name;

        if (filename && filename.lastIndexOf(".") <= 0) {
          return;
        }
        if (files[0].size > maxfilesize) {
          this.showModal(this.texts.fileSizeLimit);
          this.$refs.image.type = '';
          this.$refs.image.type = 'file';
          return;
        }
        const extension = files[0].name.split(".").pop();
        const found = ["png", "jpg", "jpe", "jpeg", "tiff", "pdf"].filter(
          ext => ext === extension.toLowerCase()
        );
        if (!found.length) {
          this.showModal(this.texts.wrongFormat);
          this.$refs.image.type = '';
          this.$refs.image.type = 'file';
          return;
        }
        this.selectedFile = files[0];
        this.setPreview(this.selectedFile);
        this.setValue(this.selectedFile);
      }
    },
    setValue (value) {
      this.$emit("component-updated", {
        value
      });
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: !!value
      });
    },
    setPreview (file) {
      const reader = new FileReader();

      this.selectedFile = file;
      reader.onload = e => {
        this.$refs.preview.src = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    sendProductPhoto (formId, triggers) {
      const formData = {
        image: this.selectedFile,
        apiUrl: this.apiUrl,
        receiptToken: this.$store.getters.receiptToken
      };

      if (this.reUpload) {
        formData["receiptToken"] = this.$route.query[this.tokenName];
        formData["customerToken"] = 1;
        // console.log("REUPLOAD",this.reUpload, formData)
      }

      this.$store.dispatch("uploadProductPhotos", formData).then(r => {
        // console.log(this.successAction, this.response);
        if (r.response && this.successAction) {
          const fn = this.successAction.fn;
          const params = this.successAction.params;
          this[fn](params, this);
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: true
          });
        }
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false
        });
      }).catch(err => {
        console.log("Error", err)
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false
        });
      });
    }
  },
  mounted () {
    if (this.value) {
      this.setPreview(this.value);
    }
    this.$eventHub.$on("sendProductPhotos-event", this.sendProductPhoto);
  },
  updated () {
    window.top.postMessage({ type: 'iframeResize', height: document.body.scrollHeight }, "*")
  }
};
</script>

<style scoped lang="scss">
.product-upload-wrapper {
  height: 100%;
  max-width: 591px;
  min-width: 500px;
  min-height: 628px;
  @media (max-width: 1024px) {
    min-height: 341px;
    min-width: 300px;
  }
}
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: 0.4s;
}
.uploadIcon {
  position: absolute;
  top: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.uploadDescription {
  font-size: 12px;
  line-height: 22px;
}
.receiptUploaderWrapper {
  border: 1px solid #dddfe1;
  box-sizing: border-box;
  border-radius: 8px;
  min-height: 240px;
  padding: 0;
  margin-bottom: 20px;
  width: 86%;
  .receiptScannerPlaceholder {
    color: #97999b;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.text-center {
  text-align: center !important;
}
.hidden {
  display: none;
}
.receipt-uploader {
  overflow: hidden;
}

.wrapper_square_img {
  position: relative;
  display: inline-block;
  width: 89%;
}
.delete_block {
  position: absolute;
  top: 0;
  right: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
    transition: transform .5s;
  }
}
.delete_block .delete_img {
  width: 16px;
}
.section-title {
  color: #474747;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.16px;
  text-align: center;
  margin-bottom: 30px;
}
.upload-canvas {
  box-sizing: border-box;
  height: 176px;
  border: 2px dashed #979797;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  transition: background-color 0.5s;
  cursor: pointer;

  &:hover {
    background-color: #fff;
  }

  .upload-text {
    color: #474747;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.16px;
  }

  .upload-icon {
    text-align: center;
  }
}
.upload-hint {
  margin-top: 14px;
  opacity: 0.64;
  color: #474747;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.14px;
  line-height: 16px;
}
.inputfile {
  display: none;
}
.wrapper_file_upload {
  height: 100%;
  background-color: #F5FAFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  padding: 54px;
  outline: 1px dashed #6676D1;
  @media (max-width: 767px) {
    padding-top: 0;
    padding-left: 25px;
    padding-right: 25px;
  }
  &_prog {
    border-style: solid;
  }
  .file_upload {
    // max-width: 350px;
    width: 100%;
    text-align: left;
    cursor: pointer;
    padding-top: 40px;
    padding-bottom: 20px;
    .text {
      &1 {
        font-size: 24px;
        line-height: 30px;
        font-weight: bold;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;

        padding-bottom: 30px;
      }

      &2 {
        font-size: 16px;
        line-height: 25px;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;
        @media (max-width: 767px) {
          display: none;
        }
      }
    }
  }
}
.upload_img {
  // width: 100px;
  margin-bottom: 30px;
}
.file_upload input[type="file"] {
  display: none;
}
.color-green {
  color: var(--brand-color) !important;
}
.btn_abs {
  position: absolute;
  margin: 0 auto;
  bottom: 40px;
}
.btn {
  padding: 10px 30px;
  width: 50%;
  @media (max-width: 767px) {
    width: 70%;
    padding: 10px 30px;
  }
}

.poz_rel {
  position: relative;
  background: #FFFFFF;
  box-shadow: 0px 16px 32px -3px #EBEBEB;
  border-radius: 16px;
  padding: 24px;
}
.container_sm {
  max-width: 710px !important;
}
</style>
